import { useCallback, useRef, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import MediaService from '../../services/MediaService';
import UnitNavigation from '../../components/Navigation/UnitNavigation';
import Surprise from '../../components/World/Surprise/Surprise';
import { GetUserVideo, getVideo } from '../../s3Func/s3Download';

const Module10Nav = () => {
  const { module10 } = useSelector((state) => state.module10, shallowEqual);
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);

  /*****************
   *  BG Image Logic
   * ***************/

  const [displaySurprise, setDisplaySurprise] = useState(false);
  const [surpriseConfig, setSurpriseConfig] = useState(null);
  const bgImage = useRef();

  const checkScreenSize = () => {
    const desktopImage =
      '/Module10Images/Module10NavImages/Background_Unit2_Mod5_JourneyMap.png';
    const mobileImage =
      '/Module10Images/Module10NavImages/Background_Unit2_Mod5_JourneyMap_phone_1.png';

    bgImage.current =
      window.screen && window.screen.width < 1025 ? mobileImage : desktopImage;
  };

  const resizeListener = useCallback(() => {
    window.addEventListener(
      'resize',
      (event) => checkScreenSize(event.target),
      true
    );
  }, []);

  resizeListener();
  checkScreenSize();

  const backgroundPath =
    bgImage.current && MediaService.getImage(bgImage.current, login);
  const worldBG = MediaService.getImage(
    '/Module10Images/Day+Scene+Nav+Template+-+ML+%E2%80%93+6.png',
    login
  );

  /*****************
   *  Day Logic
   * ***************/

  const getDayConfig = useCallback((dayNumber) => {
    const filledImageUrl = `/Module10Images/Module10NavImages/JourneyMap_Mod5_Day${dayNumber}.png`;
    const outlinedImageUrl = `/Module10Images/Module10NavImages/JourneyMap_Mod5_Outline_Day${dayNumber}.png`;

    return {
      dayNumber,
      destiny: '/close',
      filledImageUrl,
      outlinedImageUrl,
    };
  }, []);

  const daysArray = [...Array(8).keys()];
  const DAYS_CONFIG = daysArray.map((index) => getDayConfig(index + 1));

  const SURPRISE_VIDEO = {
    song: 'appfiles/close/close_full_song_instrumental.m4a',
    slides: [
      `influencers/${login.influencerid}/close_affirmation.mp4`,
      `userfiles/${module10.StudentID}/close_celebration_surprise_5.mp4`,
      `influencers/${login.influencerid}/close_affirmation.mp4`,
      'appfiles/close/close_greeting_5.mp4',
      `userfiles/${module10.StudentID}/greet_practice_video_5.mp4`,
      'appfiles/close/close_question_5.mp4',
      `userfiles/${module10.StudentID}/answer_practice_video_5.mp4`,
      'appfiles/close/close_acknowledge_5.mp4',
      `userfiles/${module10.StudentID}/ask_practice_video_5.mp4`,
      'appfiles/close/close_response_5.mp4',
      `userfiles/${module10.StudentID}/respond_practice_video_5.mp4`,
      'appfiles/close/close_close_5.mp4',
      `userfiles/${module10.StudentID}/close_practice_video_5.mp4`,
      `influencers/${login.influencerid}/respond_video_message.mp4`,
      `influencers/${login.influencerid}/respond_affirmation.mp4`,
      `userfiles/${module10.StudentID}/close_celebration_surprise_9.mp4`,
      `influencers/${login.influencerid}/close_affirmation.mp4`,
    ],
  };

  const handleSurpriseClick = async () => {
    let { slides, song, video } = SURPRISE_VIDEO;

    slides = await Promise.all(
      slides.map(async (url) => await GetUserVideo(url))
    );
    song = await getVideo(song, login);

    setSurpriseConfig({ video, slides, song });
    setDisplaySurprise(true);
  };

  /*****************************
   *  Component configuration
   * ***************************/

  return (
    <>
      {displaySurprise && (
        <Surprise
          background={worldBG}
          setDisplaySurprise={setDisplaySurprise}
          video={surpriseConfig.video}
          song={surpriseConfig.song}
          slides={surpriseConfig.slides}
          onSurpriseEnded={() => setDisplaySurprise(false)}
        />
      )}

      {backgroundPath && (
        <UnitNavigation
          moduleName='MODULE10'
          module={module10}
          days={DAYS_CONFIG}
          totalDays={8}
          unitDestiny='/unit2'
          nextDestiny='/unit3'
          backgroundPath={backgroundPath}
          onSurpriseClick={handleSurpriseClick}
          unit={2}
          animal={MediaService.getImage('/Images/Button_BirdHead.png', login)}
        />
      )}
    </>
  );
};
export default Module10Nav;
